import { UserRole } from '@upstart/harmony/lib/constants';
import { get } from 'lodash';
import buildMenu from '../DealerNav/menuBuilder';

const MenuItems = (user, currentUserDealer) => {
  const loggedInAsDealer = !!get(user, 'dealer_id');
  const onlineDeskingEnabled = get(currentUserDealer, 'desking.onlineDesking');
  const econtractingEnabled = get(
    currentUserDealer,
    'featureConfig.eContracting.enabled',
  );

  return [
    {
      name: 'Showroom View',
      getUrl: () => '/dashboard',
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.DESKING_MANAGER,
        UserRole.LIMITED_DEALER_ADMIN,
      ],
      adminItem: false,
    },
    onlineDeskingEnabled || econtractingEnabled
      ? {
          name: 'Online View',
          getUrl: () => '/dashboard-online',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.DESKING_MANAGER,
            UserRole.LIMITED_DEALER_ADMIN,
          ],
          adminItem: false,
        }
      : null,
    {
      name: 'Client Management',
      subMenu: true,
      subList: [
        {
          name: 'Dealer',
          // get the first accessible tab under Dealer sub nav
          getUrl: dealerUser => {
            const menu = buildMenu(dealerUser);
            // because this isn't an ADMIN tab, user will always have a dealer_id
            return menu[0].getUrl(dealerUser.dealer_id);
          },
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
            UserRole.LIMITED_DEALER_ADMIN,
          ],
          adminItem: false,
        },
        {
          name: 'Dealers',
          getUrl: () => '/dealers',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
          ],
          adminItem: true,
        },
        {
          name: 'Groups',
          getUrl: () => '/groups',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
          ],
          showAll: true,
        },
        {
          name: 'Websites',
          getUrl: () => '/websites',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
          ],
          showAll: true,
        },
        {
          name: 'Translations',
          getUrl: () => '/translationRules',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
          ],
          adminItem: true,
        },
        {
          name: 'Fonts',
          getUrl: () => '/fonts',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
          ],
          adminItem: true,
        },
      ],
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.ACCOUNT_MANAGER,
        UserRole.LIMITED_DEALER_ADMIN,
      ],
      showAll: true,
      getUrl: () =>
        loggedInAsDealer ? `/dealer/${user.dealer_id}` : '/dealers',
    },
    {
      name: 'Users',
      getUrl: () => '/employees',
      roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
      adminItem: true,
    },
    {
      name: 'Inventory',
      subMenu: true,
      subList: [
        {
          name: 'Feeds',
          getUrl: () => '/feeds',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
          ],
          adminItem: true,
        },
        {
          name: 'Feed Views',
          getUrl: () => '/feedviews',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
          ],
          adminItem: true,
        },
        {
          name: 'Mappings',
          getUrl: () => '/feedMappings',
          roles: [
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.READ_ONLY_ADMIN,
            UserRole.ACCOUNT_MANAGER,
          ],
          adminItem: true,
        },
      ],
      getUrl: () => '/feeds',
      roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
      adminItem: true,
    },
    {
      name: 'Roles & Permissions',
      getUrl: () => '/roles',
      roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
      adminItem: true,
    },
    {
      name: 'Internal Dashboard',
      getUrl: () => '/internal-dashboard',
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.ACCOUNT_MANAGER,
      ],
      adminItem: true,
    },
    {
      name: 'Results Dashboard',
      getUrl: () => '/results-dashboard',
      roles: [UserRole.DEALER_MANAGER],
    },
    {
      name: 'Pricing Matrix (Online)',
      getUrl: () => '/pricing-matrix/online',
      roles: [UserRole.PRICING_MANAGEMENT],
    },
    {
      name: 'Pricing Matrix (In-Store)',
      getUrl: () => '/pricing-matrix/instore',
      roles: [UserRole.PRICING_MANAGEMENT],
    },
    {
      name: 'Announcements',
      getUrl: () => '/announcements',
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.ACCOUNT_MANAGER,
      ],
      adminItem: true,
    },
    {
      name: 'Upstart Loan Status',
      getUrl: () => '/upstart-loan-status',
      roles: [
        UserRole.SUPER_ADMIN,
        UserRole.ADMIN,
        UserRole.READ_ONLY_ADMIN,
        UserRole.DEALER_ADMIN,
        UserRole.LIMITED_DEALER_ADMIN,
        UserRole.DESKING_MANAGER,
      ],
      adminItem: false,
    },
    {
      name: 'App Management',
      getUrl: () => '/app-management',
      roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.READ_ONLY_ADMIN],
      adminItem: true,
    },
  ];
};

export const hasAnyOfRole = user => ({ roles, adminItem, showAll }) => {
  const userRoles = get(user, 'roles', []);
  const loggedInAsDealer = !!get(user, 'dealer_id');
  const hasValidRole = userRoles.some(role => roles.includes(role));

  // These are tabs that all users will see
  if (showAll) {
    return hasValidRole;
  }

  // Admin-tabs should show only if admin is logged in but is not logged in as a Dealer
  if (adminItem) {
    return hasValidRole && !loggedInAsDealer;
  }
  // other tabs should show only when the user is logged in to a Dealer account
  return hasValidRole && loggedInAsDealer;
};

export default (user, currentUserDealer) =>
  MenuItems(user, currentUserDealer)
    .filter(item => !!item)
    .filter(hasAnyOfRole(user));
